import React from 'react';
import { bool, number, shape, string } from 'prop-types';
import { Box, Typography, useTheme } from '@mui/material';

const CardLabels = ({ listType, activeAuthorization }) => {
  const theme = useTheme();
  const productLabel = activeAuthorization ? 'Product Active' : 'Product Inactive';
  const extendedLoadingActive = activeAuthorization?.extendedLoadingAccepted;

  const extendedLoadingLabel = extendedLoadingActive
    ? 'Extended Loading Active'
    : 'Extended Loading Inactive';

  return (
    <>
      {listType === 'baseProducts' && (
        <Box
          bgcolor={extendedLoadingActive ? 'transparent' : theme.palette.graphic.lighter}
          border={1}
          borderColor={extendedLoadingActive ? theme.palette.graphic.light : 'transparent'}
          borderRadius="4px"
          gridColumn="1 / 3"
          justifySelf="stretch"
          m={1}
          minHeight="39px"
          p={theme.spacing(1, 0.5)}
          textAlign="center"
        >
          <Typography color="textPrimary" sx={{ paddingTop: 2 }} variant="body1">
            {extendedLoadingLabel}
          </Typography>
        </Box>
      )}
      <Box
        alignItems="center"
        bgcolor={
          activeAuthorization ? theme.palette.primary.lighter : theme.palette.graphic.lighter
        }
        borderRadius="4px"
        gridColumn="1 / 3"
        justifyContent="center"
        justifySelf="stretch"
        m={1}
        minHeight="39px"
        p={theme.spacing(1, 0.5)}
        textAlign="center"
      >
        <Typography color="textPrimary" sx={{ paddingTop: 2 }} variant="body1">
          {productLabel}
        </Typography>
      </Box>
    </>
  );
};

export default CardLabels;

CardLabels.propTypes = {
  activeAuthorization: shape({
    active: bool,
    authorizationCount: number,
    extendedLoadingAccepted: bool,
    extendedLoadingAllowed: bool,
    lastUsed: string,
    productLocationAuthorizationId: number,
    type: string,
  }),
  listType: string.isRequired,
};

CardLabels.defaultProps = {
  activeAuthorization: {
    active: false,
    authorizationCount: null,
    extendedLoadingAccepted: false,
    extendedLoadingAllowed: false,
    lastUsed: null,
    productLocationAuthorizationId: null,
    type: '',
  },
};
